module.exports = __webpack_public_path__ + "img/customer01.c91de5b5.jpg";